import { Col, Row } from '@paypalcorp/pp-react'
import { Dropdown, DropdownItem } from '@paypalcorp/ppods-react'
import { useApplicationContext } from '../../../context/ApplicationContext'
import React, { useEffect, useState } from 'react'
import { getDateRangeSelection } from '../../../utils/session-utils'

function DateRangeSelect() {
  const { setDateRangeSelectorStart, setDateRangeSelectorEnd, setReloadPage } =
    useApplicationContext()

  const [selectedRecord, setSelectedRecord] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()

  const setDateRangeSelection = (range) => {
    window.localStorage.setItem('dateRange', range)
    setSelectedRecord(range)
  }

  const dateRangeOptions = [
    {
      value: '1',
      primaryText: 'Last 1 hour',
    },
    {
      value: '12',
      primaryText: 'Last 12 hours',
    },
    {
      value: '24',
      primaryText: 'Last 24 hours',
    },
    {
      value: '168',
      primaryText: 'Last 7 days',
    },
    {
      value: '336',
      primaryText: 'Last 14 days',
    },
  ]

  const subtractHoursToDate = (intHours) => {
    let numberOfMlSeconds = new Date().getTime()
    let addMlSeconds = intHours * 60 * 60 * 1000
    let newDateObj = new Date(numberOfMlSeconds - addMlSeconds)

    setStartDate(newDateObj)
    setEndDate(new Date())

    // also store via global ApplicationContext
    setDateRangeSelectorStart(newDateObj)
    setDateRangeSelectorEnd(new Date())
  }

  useEffect(() => {
    let dateRange = getDateRangeSelection()
    setSelectedRecord(dateRange ? dateRange : dateRangeOptions[1].value)
    subtractHoursToDate(dateRange ? dateRange : dateRangeOptions[1].value)
  }, [])

  const daterangecontent = (
    <>
      <Row>
        <Col>
          <Dropdown
            id="selected-date-range"
            titleText=""
            label={
              dateRangeOptions.find(
                (dateRange) => dateRange.value === selectedRecord,
              )?.primaryText || 'Date range'
            }
            value={selectedRecord}
            startdate={startDate}
            enddate={endDate}
            selected={(event) => {
              const value = event.detail.item.value
              setDateRangeSelection(value)
              subtractHoursToDate(value)
              setReloadPage('yes')
            }}
            style={{
              display: 'inline-table',
              width: '153px',
              border: '1px solid #ccc',
              borderRadius: '6px',
              position: 'relative',
              zIndex: '1',
            }}
            data-dxa="Date Range Selector, date-range-value-dropdown click"
          >
            {dateRangeOptions.map((option) => (
              <DropdownItem
                value={option.value}
                selected={selectedRecord === option.value}
                key={option.value}
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '6px',
                }}
              >
                {option.primaryText}
              </DropdownItem>
            ))}
          </Dropdown>
        </Col>
      </Row>
    </>
  )

  return <>{daterangecontent}</>
}

export default DateRangeSelect
